import { render, staticRenderFns } from "./caseAorta.vue?vue&type=template&id=97ad0f50&scoped=true"
import script from "./caseAorta.vue?vue&type=script&lang=js"
export * from "./caseAorta.vue?vue&type=script&lang=js"
import style0 from "./caseAorta.vue?vue&type=style&index=0&id=97ad0f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ad0f50",
  null
  
)

export default component.exports